<div id="{{menuItemId}}" class="menuItemHolder">
  <div id="{{menuItemId}}-item" class="contextMenuItem">{{blockType}} <span class="menuItemArrow">{{>icon uuid=(concat 'menuItemArrowIcon-' randomId) prefix="far" name="fa-arrow-right" size="fa-lg"}}</span></div>
  <div id="{{menuItemId}}-subviewHolder" class="subviewHolder"></div>
</div>